import styled from 'styled-components'

export const Col = styled.div`
  display: flex;
  margin: 10px;
  @media (max-width: 700px) {
    display: block;
  }
`

export const Row = styled.div`
  flex: 1;
`
